import { defineAsyncComponent } from "vue"

/*异步获取模板 */
const loadComponent=(name)=>{
     return defineAsyncComponent(() =>
        import('/src/components/home/member/memberModel/'+name+'/'+name+'.vue')
    )
}

const componentList=([/**制卡 */
    {
        tagName:"business-card-member",
        name:'businessCardMember'
    },
    /**会员办卡 */
    {
        tagName:"membership-card", 
        name:'membershipCard'
    },
    /**会员充值 */
    {
        tagName:"member-recharge", 
        name:'memberRecharge'
    },
    /**卡资产调整 */
    {
        tagName:"card-asset-change", 
        name:'cardAssetChange'
    },
    /**卡 挂失 或 停用 */
    {
        tagName:"card-lost-or-stop", 
        name:'cardLostOrStop'
    },
    /**退卡*/
    {
        tagName:"card-return", 
        name:'cardReturn'
    },
    /**修改密码*/
    {
        tagName:"card-pwd-modify", 
        name:'cardPwdModify'
    },
    /**修改会员信息*/
    {
        tagName:"member-info-modify", 
        name:'memberInfoModify'
    },
    /**补卡*/
    {
        tagName:"card-reissue", 
        name:'cardReissue'
    },
    /**绑卡*/
    {
        tagName:"card-bind", 
        name:'cardBind'
    },
    /**卡解绑*/
    {
        tagName:"card-release-bind", 
        name:'cardReleaseBind'
    },
    /**手动核销券*/
    {
        tagName:"member-info-check-coupon",
        name:'memberInfoCheckCoupon'
    },
    /**会员卡消费明细表*/
    {
        tagName:"card-consume-report", 
        name:'cardConsumeReport'
    },
    /**会员卡充值明细表*/
    {
        tagName:"card-recharge-report", 
        name:'cardRechargeReport'
    },
    /**会员交易汇总表*/
    {
        tagName:"card-day-report", 
        name:'cardDayReport'
    },
    /**会员卡交易轨迹表*/
    {
        tagName:"card-track-report", 
        name:'cardTrackReport'
    },
    /**会员新增统计报表*/
    {
        tagName:"new-member-report", 
        name:'newMemberReport'
    },
    /**微生活会员充值*/
    {
        name:'willAddMoney'
    },
    /**微生活 券核销 */
    {
        name:'willCheckCoupon'
    }
]).map(it=>{
    if(!it.tagName){
        it.tagName=it.name.replace(/[A-Z]/g,(str)=>{return "-"+str.toLocaleLowerCase()});
    }
    return it;
})



/***纪录所有报表 模板 */
export default {
    /**报表模板 */
    components:{},
    /**模板名称 @param name 不区分大小写和- _符号*/
    getComponent(name){
        name=name?.toLocaleLowerCase().replace(/[-_]/g,'');
        
        let component=componentList.find(it=>it.name.toLocaleLowerCase()==name?.toLocaleLowerCase());
        if(component){
            if(!this.components[component.name]){
                this.components[component.name]=loadComponent(component.name);
            }
            return component.tagName;
        }
        return;
    }
}